import {
  makeApiProvider,
  useApiQuery,
} from '@pflegenavi/shared-frontend/platform';
import { createContext } from 'react';
import type { IServiceProviderAppApi } from './api';
import { ServiceProviderAppApi } from './api';
import type {
  ServiceProviderAppControllerQueryTypes,
  ServiceProviderAppControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import type { QueryKey, UseQueryOptions, UseQueryResult } from 'react-query';
import { useQueryClient } from 'react-query';
import type { ResidentState } from '@pflegenavi/shared/api';

const ApiContext = createContext<IServiceProviderAppApi | undefined>(undefined);
const {
  useApi: useServiceProviderAppApi,
  ApiProvider: ServiceProviderAppApiProvider,
} = makeApiProvider({
  name: 'ServiceProviderApp',
  ApiContext,
  newApi: (tenantId, auth, apiUrl) =>
    new ServiceProviderAppApi(tenantId, auth, apiUrl),
});

export {
  useServiceProviderAppApi,
  ServiceProviderAppApiProvider,
  ApiContext as ServiceProviderAppApiContext,
};
export type { IServiceProviderAppApi } from './api';

export const GET_RESIDENT_LIST_KEY = (
  tenant: string,
  nursingHomeId: string,
  residentStates?: ResidentState[],
  residentIds?: string[]
): QueryKey => [
  'get-resident-list',
  tenant,
  nursingHomeId,
  {
    residentStates,
    residentIds,
  },
];

// TODO: Remove
export const useServiceProviderResidentList = (
  params: ServiceProviderAppControllerQueryTypes['getResidentList'],
  options?: UseQueryOptions<
    ServiceProviderAppControllerResultTypes['getResidentList']
  >
): UseQueryResult<
  ServiceProviderAppControllerResultTypes['getResidentList']
> => {
  const queryClient = useQueryClient();
  const key = GET_RESIDENT_LIST_KEY(
    params.tenant,
    params.nursingHomeId,
    params.residentStates,
    params.residentIds
  );
  return useApiQuery(
    useServiceProviderAppApi,
    key,
    (api) => {
      return api.getResidentList({ params });
    },
    {
      initialData: () => queryClient.getQueryData(key),
      initialDataUpdatedAt: () => queryClient.getQueryState(key)?.dataUpdatedAt,
      ...options,
    }
  );
};
